import { FieldProps } from 'formik';
import { useLeadStatuses } from '../../../entities/lead/lead-status';
import { CollectionMultiSelect } from '../collection-multiple-autocomplete';
import { FilterCollectionMultiSelect } from '../collection-multiple-autocomplete-filter';
import { CollectionAutocomplete } from '../collection-autocomplete';

export const LeadStatusPickerField = ({ form, field, meta, multi = false, customSize, compactTags = false, ...rest }: FieldProps<number, any> & { multi?: boolean; customSize?: number; compactTags?: boolean }) => {
  const statuses = useLeadStatuses();
  return multi ? (
    compactTags ? (
      <FilterCollectionMultiSelect customSize={customSize} field={field} form={form} isLoading={statuses.isLoading} items={statuses.items} clearable={true} label={'Статус'} meta={meta} {...rest} />
    ) : (
      <CollectionMultiSelect customSize={customSize} field={field} form={form} isLoading={statuses.isLoading} items={statuses.items} clearable={true} label={'Статус'} meta={meta} {...rest} />
    )
  ) : (
    <CollectionAutocomplete field={field} form={form} isLoading={statuses.isLoading} items={statuses.items} clearable={true} label={'Статус'} meta={meta} {...rest} />
  );
};
